import R2Dom from "../helpers/R2Dom";

R2Dom.Methods.example = function (_this) {
    console.warn("src/scripts/methods/example.js Method!", _this);
}